/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  control_number: z.string(),
  official_name: z.string(),
  short_name: z.string(),
  client_id: z.number(),
  client_department: z.string(),
  contractor_name: z.string(),
  location: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  paint_kind: z.string(),
  structure_form: z.string(),
  environment_category: z.string(),
  overhead_condition: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const WorkBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type WorkBase = z.infer<typeof base>;
export type WorkBasePutPayload = z.infer<typeof put>;
export type WorkBasePatchPayload = z.infer<typeof patch>;
export type WorkBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type WorkBaseCreateAttributes = z.infer<typeof create>;
export type WorkBaseUpdateAttributes = z.infer<typeof update>;
export type WorkBaseCacheAttributes = z.infer<typeof cache>;
export type WorkBaseCachesAttributes = z.infer<typeof caches>;